import styled from "styled-components";
import { Button } from "../../../../../../base/buttons/button/index.js";
import { FlexMixin, FontMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
import tabsThemes from "./themes/index.js";
export const ProductCardTab = styled.ul.withConfig({
    displayName: "styled__ProductCardTab",
    componentId: "sc-127ab5b2-0"
})`
	border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.light};
	${FlexMixin({
    justify: 'space-between'
})}
	margin: 0 12px;

	& > li {
		flex-basis: 50%;
		position: relative;
	}

	& > li:last-child:before {
		background-color: ${({ theme  })=>theme.colors.grays.light};
		content: '';
		height: 26px;
		left: 0;
		position: absolute;
		top: 8px;
		width: 1px;
	}

	${Button} {
		color: ${({ theme  })=>theme.colors.grays.base};
		cursor: pointer;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		font-size: 0.875rem;
		${FontMixin({
    weight: 'regular'
})}
		padding: 12px 0;
		text-transform: uppercase;
		width: 100%;
		background: unset;
		border: 0;
		outline: 0;

		${({ theme  })=>theme.media.down('tablet')} {
			color: ${({ theme  })=>theme.colors.grays.dark};
		}
	}

	& ${Button}.is-active {
		color: ${({ theme  })=>theme.colors.grays.dark};
		${FontMixin({
    weight: 'medium'
})}
	}

	${({ theme  })=>tabsThemes[theme.id]?.ProductCardTab?.()};
`;

//# sourceMappingURL=styled.js.map